import { render, staticRenderFns } from "./TheTourItem.vue?vue&type=template&id=2f2cc84a&scoped=true"
import script from "./TheTourItem.vue?vue&type=script&lang=js"
export * from "./TheTourItem.vue?vue&type=script&lang=js"
import style0 from "./TheTourItem.vue?vue&type=style&index=0&id=2f2cc84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2cc84a",
  null
  
)

export default component.exports